import React from 'react'
import * as Yup from 'yup'
import styles from './_.module.css'

/* To make a word bold */
export const highlightWord = (word: string): React.ReactNode => {
  return <span className={styles.highlightedWord}>{word}</span>
}

/* Apply Promo Code field  */
export const promoCodeField = [
  {
    type: 'text',
    name: 'promo_code',
    label: 'Enter Promo Code:',
    grid: 'grid-xl-10',
    required: true,
  },
]

export const getBillingInformationForm = (
  countryCode: { value: string; label: string | undefined }[],
  currencyType: number
): JsonFieldComponent[] => {
  const addressFieldsSet = [
    {
      type: 'text',
      name: 'registered_company_name',
      label: 'Registered Company Name / Individual Name:',
      grid: 'grid-xl-24',
      required: true,
    },
    {
      type: 'text',
      name: 'address_1',
      label: 'Address',
      grid: 'grid-xl-24',
      required: true,
    },
    {
      type: 'select',
      name: 'country_code',
      label: 'Country',
      grid: 'grid-xl-12',
      required: true,
      fieldProps: {
        size: 'default',
        showSearch: true,
        options: countryCode,
        disabled: true,
      },
    },
    {
      type: 'text',
      name: 'zip_code',
      label: 'Zip Code',
      grid: 'grid-xl-12',
      required: true,
    },
    {
      type: 'text',
      name: 'state',
      label: 'State',
      grid: currencyType === 1 ? 'grid-xl-12' : 'grid-xl-24',
      required: true,
      fieldProps: {
        disabled: currencyType === 1,
      },
    },
  ]
  if (currencyType === 1) {
    addressFieldsSet.push({
      type: 'text',
      name: 'company_gst',
      label: 'GST Number',
      grid: 'grid-xl-24',
      required: false,
    })
  }
  return addressFieldsSet
}

export const billingInfoValidationSchema: Yup.ObjectSchema = Yup.object({
  registered_company_name: Yup.string()
    .required('Enter Registered Company Name')
    .nullable(),
  address_1: Yup.string().required('Enter Address').nullable(),
  state: Yup.string().required('Enter State').nullable(),
  showEmail: Yup.boolean(),
  zip_code: Yup.string().required('Enter Zip Code').nullable(),
  country_code: Yup.string().required('Enter  Country').nullable(),
  company_gst: Yup.string()
    .nullable()
    .matches(
      /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[\dA-Z]$/,
      'Enter a valid GST No'
    ),
})
